import React from 'react';
import Label from 'infrastructure/js/components/Label/label.js';
import AlertPopover from 'infrastructure/js/components/popover/AlertPopover/alertPopover.js';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import { focusElementWhenReady } from 'infrastructure/js/utils/domHelper';

require('./componentWithErrorCell.scss');

export default class ComponentWithErrorCell extends React.PureComponent {

  constructor(props){
    super(props);

    this.labels = createLabelHelper('alerts.titles.');
  }

  // Explicitly kick off editing on mousedown (rather than relying on ag-grid's own
  // singleClickEdit timing) and focus the underlying input directly once it exists,
  // instead of relying on the cell editor's afterGuiAttached() grid-api hook: ag-grid
  // only calls that hook if the editor's React component instance is already mounted,
  // and since it's mounted via a portal, that mount can land a tick late - afterGuiAttached
  // is optional and isn't retried, so the hook can get silently skipped.
  handleMouseDown = () => {
    let {value, column, api, rowIndex} = this.props;
    if (!value?.params?.enabled || !column || !api || rowIndex === undefined) {
      return;
    }

    api.startEditingCell({rowIndex, colKey: column.colId});
    focusElementWhenReady(column.colId + rowIndex);
  };

  render() {
    let {value} = this.props;
    if (value) {
      if (value.errorMessage) {
        return <div className="component-with-error-cell">
          <AlertPopover
            popoverType={'error'}
            popoverComponent={<span>{value.errorMessage}</span>}
          />
          <Label text={value.errorMessage} className="error-message"/>
        </div>
      }

      return <div className="component-with-error-cell-content" onMouseDown={this.handleMouseDown}>
        <value.componentType value={value.params}/>
      </div>;
    }
    return null;
  }
}









